import PropTypes from "prop-types"
import React from "react"

// Keeps a map failure inside the map box. Google Maps is a third party script,
// and if it ever throws while the page is updating (an outage, a rejected key,
// a bug in the pin grouping), React would otherwise remove the entire page.
// With this in place the search and every center card keep working.
class MapErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return { hasError: true }
  }

  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  render() {
    const { children, fallback } = this.props
    const { hasError } = this.state

    return hasError ? fallback : children
  }
}

MapErrorBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
}

export default MapErrorBoundary
